import SegmentDataModel from '@/common/models/segment-data-model';

import invoiceFilters from '@/common/query/filter/invoice-filters';
import transactionsFilters from '@/common/query/filter/transaction-filters';
import orderFilters from '@/common/query/filter/order-filters';
import customerFilters from '@/common/query/filter/customer-filters';
import apiLogFilters from '@/common/query/filter/api-logs-filters';
import webhookLogsFilters from '@/common/query/filter/webhook-tracking-logs-filters';
import couponRedemptionsFilters from '@/common/query/filter/coupon-filters';

export default {
    [SegmentDataModel.Types.invoices]: invoiceFilters,
    [SegmentDataModel.Types.transactions]: transactionsFilters,
    [SegmentDataModel.Types.orders]: orderFilters,
    [SegmentDataModel.Types.customers]: customerFilters,
    [SegmentDataModel.Types.apiLogs]: apiLogFilters,
    [SegmentDataModel.Types.webhookLogs]: webhookLogsFilters,
    [SegmentDataModel.Types.couponRedemptions]: couponRedemptionsFilters,
};
